import Board from "components/Common/Board/Board";
import styled from "styled-components";

export const PasswordVerificationBoard = styled(Board)`
  width: 75rem;
  padding: 5rem;

  display: flex;
  flex-direction: column;
  gap: 3.4rem;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  h1 {
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 42px; /* 131.25% */
    letter-spacing: -0.96px;

    margin-bottom: 1.6rem;
  }

  h2 {
    ${({ theme }) => theme.typography.body1.regular};
    color: ${({ theme }) => theme.color.text.secondary};
  }

  .password-verification__header {
    text-align: center;
  }
`;
